//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Colorable from "../../mixins/Colorable";
import GridElement from "../Layout/Grid/GridElement";
import Shadowable from "../../mixins/Shadowable";
const Icon = () => import('../Icon/Icon')
const Btn = () => import('../Button/Btn')

export default {
    name: "Alert",

    components: {Icon, Btn},

    mixins: [Colorable, GridElement, Shadowable],

    props: {
        // Renders the alert without a lighter background
        text: {
            type: Boolean,
            default: false
        },

        // The HTML content to render in the alert
        content: {
            type: String,
            default: null
        },

        // The text to display on a button to navigate the user to a corresponding page
        // or true to display the button with a default 'add' text
        button: {
            type: String | Boolean,
            default: null
        },

        // The icon to place on the button
        buttonIcon: {
            type: String | Boolean,
            default: null
        },

        // The route to navigate the user to when he clicks on the button
        to: {
            type: String | Object,
            default: null
        },

        type: {
            type: String,
            default: 'info',
            validator: function (value) {
                // The value must match one of these strings
                return ['success', 'warning', 'error', 'info', 'primary'].indexOf(value) !== -1
            }
        },

        icon: {
            type: [String, Boolean],
            default: null
        },

        rounded: {
            type: [String, Boolean],
            default: 'lg'
        },

        hideIconOnMobile: {
            type: Boolean,
            default: false
        },

        // Whether to vertically align the content even on desktop devices
        vertical: {
            type: Boolean,
            default: false
        },

        // Whether a larger spacing shall be applied
        spaced: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        displayIcon() {
            if (this.icon === false) {
                return null;
            }
            if (this.icon) {
                return this.icon;
            }
            switch (this.type) {
                case 'success':
                    return this.$icons.check;
                case 'warning':
                    return this.$icons.warning;
                case 'error':
                    return this.$icons.cancel;
            }

            return this.$icons.info;
        }
    }
}
